export const roleTypeOptions = [
  {
    id: "1",
    fallback: "Project Leader",
  },
  {
    id: "2",
    fallback: "Project Viewer",
  },
  {
    id: "3",
    fallback: "Project Team Member",
  },
  {
    id: "4",
    fallback: "Approver",
  },
  {
    id: "5",
    fallback: "Notification User",
  },
  {
    id: "6",
    fallback: "Requestor",
  },
];

export const milestoneSubmittedStatus = [
  {
    id: "1",
    fallback: "Submitted for Approval",
  },
];

// Removed "Approved" and "Released" as options in #104019 to avoid confusion since they don't exist in the search index
export const milestoneStatusOptions = [
  {
    id: "0",
    fallback: "Draft",
  },
  ...milestoneSubmittedStatus,
  {
    id: "3",
    fallback: "Rejected",
  },
  {
    id: "4",
    fallback: "Skipped",
  },
];

export const userReplacementKeys = {
  projectNumber: {
    field: "projectNumber",
    key: "projectNumbers",
  },
  projectName: {
    field: "projectName",
    key: "projectName",
  },
  projectType: {
    field: "projectType",
    key: "projectType",
  },
  productCategory: {
    field: "productCategory",
    key: "productCategory",
  },
  projectStatus: {
    field: "projectStatus",
    key: "status",
  },
  secure: {
    field: "secure",
    key: "onlySecureProjects",
  },
  milestone: {
    field: "milestone",
    key: "milestone",
  },
  milestoneStatus: {
    field: "milestoneStatus",
    key: "milestoneStatus",
  },
  role: {
    field: "role",
    key: "role",
  },
  roleType: {
    field: "roleType",
    key: "roleType",
  },
  notApplicableEligible: {
    field: "notApplicableEligible",
    key: "notApplicableEligible",
  },
  allowBlank: {
    field: "allowBlank",
    key: "allowBlank",
  },
  scheduleName: {
    field: "scheduleName",
    key: "scheduleName",
  },
};

export const userReplacementStatus = {
  none: "None",
  pending: "Pending",
  complete: "Complete",
};

export const insertProjectRowDataIntoTableData = (data) => {
  const modifiedData = [];

  let currentProjectNumber = null;

  data?.forEach((item) => {
    const {
      projectNumber,
      projectId,
      projectType,
      projectStatus,
      productCategory,
      secure,
      projectName,
    } = item;
    const itemProjectNumber = projectNumber;

    if (itemProjectNumber !== currentProjectNumber) {
      currentProjectNumber = itemProjectNumber;
      modifiedData.push({
        isProjectHeader: true,
        id: `${projectId}-ProjectHeaderRow`,
        projectId,
        projectNumber: itemProjectNumber,
        projectType,
        projectStatus,
        productCategory,
        secure,
        projectName,
      });
    }

    modifiedData.push(item);
  });

  return modifiedData;
};
